// Offline fallback captured from Shopify; live data comes from /api/shop-navigation.
const snapshot = {
  "navigation": [
    {
      "text": "Locations",
      "href": "https://www.velodrom.cc/pages/locations",
      "current": false
    },
    {
      "text": "The workshop",
      "href": "https://www.velodrom.cc/pages/workshops",
      "current": false
    },
    {
      "text": "Bike rental",
      "href": "https://www.velodrom.cc/pages/bike-rental",
      "current": false
    },
    {
      "text": "Bike Builder",
      "href": "https://bike-builder.onrender.com/",
      "current": true
    },
    {
      "text": "Stories",
      "href": "https://www.velodrom.cc/global/stories/",
      "current": false
    },
    {
      "text": "Contact",
      "href": "https://www.velodrom.cc/pages/contact",
      "current": false
    }
  ],
  "categories": [
    {
      "text": "Clothing Clearance 2026 +30% Off",
      "href": "https://www.velodrom.cc/collections/winter-selection-2026",
      "links": []
    },
    {
      "text": "Fresh Latest Launches New Arrivals",
      "href": "https://www.velodrom.cc/collections/fresh-latest-launches",
      "links": []
    },
    {
      "text": "Velodrom Collection SS26",
      "links": [
        {
          "text": "See all",
          "href": "https://www.velodrom.cc/collections/velodrom-vcc"
        },
        {
          "text": "Velodrom SS26 NEW DROP",
          "href": "https://www.velodrom.cc/collections/velodrom-vcc"
        },
        {
          "text": "Velodrom Short Sleeve Jerseys",
          "href": "https://www.velodrom.cc/collections/velodrom-short-sleeve-jerseys"
        },
        {
          "text": "Velodrom Bib Shorts",
          "href": "https://www.velodrom.cc/collections/velodrom-bibs-and-tights"
        },
        {
          "text": "Velodrom Long Sleeve Jerseys",
          "href": "https://www.velodrom.cc/collections/velodrom-long-sleeve-jerseys"
        },
        {
          "text": "Velodrom Lifestyle",
          "href": "https://www.velodrom.cc/collections/velodrom-lifestyle"
        },
        {
          "text": "Velodrom Jackets and Gilets",
          "href": "https://www.velodrom.cc/collections/velodrom-jackets-and-gilets"
        },
        {
          "text": "Velodrom Bundle Jersey + Bib 20% Discount",
          "href": "https://www.velodrom.cc/collections/velodrom-jersey-bundles-2026"
        }
      ]
    },
    {
      "text": "Mens Cycling Apparel",
      "links": [
        {
          "text": "Short Sleeve Jerseys",
          "href": "https://www.velodrom.cc/collections/short-sleeve-cycling-jerseys"
        },
        {
          "text": "Long Sleeve Cycling Jerseys",
          "href": "https://www.velodrom.cc/collections/long-sleeve-cycling-jerseys"
        },
        {
          "text": "Bibshorts",
          "href": "https://www.velodrom.cc/collections/bib-shorts"
        },
        {
          "text": "Gilets",
          "href": "https://www.velodrom.cc/collections/cycling-gilets"
        },
        {
          "text": "Baselayers",
          "href": "https://www.velodrom.cc/collections/baselayers"
        },
        {
          "text": "Gloves",
          "href": "https://www.velodrom.cc/collections/gloves"
        },
        {
          "text": "Socks",
          "href": "https://www.velodrom.cc/collections/cycling-socks"
        },
        {
          "text": "Jackets",
          "href": "https://www.velodrom.cc/collections/cycling-jackets"
        },
        {
          "text": "Warmers",
          "href": "https://www.velodrom.cc/collections/warmers"
        },
        {
          "text": "Winter Tights",
          "href": "https://www.velodrom.cc/collections/winter-tights"
        },
        {
          "text": "Overshoes",
          "href": "https://www.velodrom.cc/collections/overshoes"
        },
        {
          "text": "Skinsuits",
          "href": "https://www.velodrom.cc/collections/skinsuits"
        },
        {
          "text": "All Winter Apparel Men",
          "href": "https://www.velodrom.cc/collections/autumn-winter-cycling-clothing-men"
        }
      ]
    },
    {
      "text": "Women Cycling Apparel",
      "links": [
        {
          "text": "See all",
          "href": "https://www.velodrom.cc/collections/women-cycling-clothing"
        },
        {
          "text": "All Winter Apparel Women",
          "href": "https://www.velodrom.cc/collections/autumn-winter-cycling-clothing-women"
        },
        {
          "text": "Jerseys",
          "href": "https://www.velodrom.cc/collections/women-short-sleeve-cycling-jerseys"
        },
        {
          "text": "Baselayers",
          "href": "https://www.velodrom.cc/collections/women-baselayers"
        },
        {
          "text": "Gilets",
          "href": "https://www.velodrom.cc/collections/gilets-women"
        },
        {
          "text": "Gloves",
          "href": "https://www.velodrom.cc/collections/women-cycling-gloves"
        },
        {
          "text": "Socks",
          "href": "https://www.velodrom.cc/collections/women-cycling-socks"
        },
        {
          "text": "Jackets",
          "href": "https://www.velodrom.cc/collections/womens-jackets"
        },
        {
          "text": "Winter Tights",
          "href": "https://www.velodrom.cc/collections/women-winter-tights"
        },
        {
          "text": "Bibshorts",
          "href": "https://www.velodrom.cc/collections/women-cycling-bib-shorts"
        }
      ]
    },
    {
      "text": "Helmets-Shoes-Sunglasses",
      "links": [
        {
          "text": "Helmets",
          "href": "https://www.velodrom.cc/collections/cycling-helmets"
        },
        {
          "text": "Road Cycling Shoes",
          "href": "https://www.velodrom.cc/collections/road-cycling-shoes"
        },
        {
          "text": "MTB/Gravel Shoes",
          "href": "https://www.velodrom.cc/collections/gravel-shoes"
        },
        {
          "text": "Eyewear",
          "href": "https://www.velodrom.cc/collections/eyewear"
        },
        {
          "text": "Cycling Caps",
          "href": "https://www.velodrom.cc/collections/caps"
        }
      ]
    },
    {
      "text": "Cycling Accessories",
      "links": [
        {
          "text": "Spare Tubes",
          "href": "https://www.velodrom.cc/collections/spare-tubes"
        },
        {
          "text": "CO2 & Pumps",
          "href": "https://www.velodrom.cc/collections/air-pumps-and-co2"
        },
        {
          "text": "Floor Pumps",
          "href": "https://www.velodrom.cc/collections/floor-air-pumps"
        },
        {
          "text": "Electric Pumps",
          "href": "https://www.velodrom.cc/collections/electric-pumps"
        },
        {
          "text": "Bidons & Bottle Cages",
          "href": "https://www.velodrom.cc/collections/bidons"
        },
        {
          "text": "Multitools",
          "href": "https://www.velodrom.cc/collections/multitools"
        },
        {
          "text": "Bells",
          "href": "https://www.velodrom.cc/collections/bells"
        },
        {
          "text": "Cycling Accessories",
          "href": "https://www.velodrom.cc/collections/cycling-accessories"
        },
        {
          "text": "Tubeless Stuff",
          "href": "https://www.velodrom.cc/collections/tubeless-stuff"
        },
        {
          "text": "Handlebar Bags",
          "href": "https://www.velodrom.cc/collections/bags"
        },
        {
          "text": "Saddle Bags",
          "href": "https://www.velodrom.cc/collections/saddle-bags"
        },
        {
          "text": "Bike Packing",
          "href": "https://www.velodrom.cc/collections/apidura"
        },
        {
          "text": "Frame Bags & Musettes",
          "href": "https://www.velodrom.cc/collections/frame-bags-musettes"
        },
        {
          "text": "Hydration Packs",
          "href": "https://www.velodrom.cc/collections/hydration-packs"
        },
        {
          "text": "Luggage and Bike Boxes",
          "href": "https://www.velodrom.cc/collections/luggage-travel"
        },
        {
          "text": "Bike Tools",
          "href": "https://www.velodrom.cc/collections/bike-tools"
        },
        {
          "text": "Chain Lube",
          "href": "https://www.velodrom.cc/collections/chain-lube"
        },
        {
          "text": "Cleaning and degreasing",
          "href": "https://www.velodrom.cc/collections/maintenance-and-cleaning"
        },
        {
          "text": "Nutrition",
          "href": "https://www.velodrom.cc/collections/nutrition"
        },
        {
          "text": "Nutrition Drinks",
          "href": "https://www.velodrom.cc/collections/nutrition-drinks"
        },
        {
          "text": "Nutrition Gels",
          "href": "https://www.velodrom.cc/collections/nutrition-gel"
        },
        {
          "text": "Nutrition Bars",
          "href": "https://www.velodrom.cc/collections/nutrition-bars"
        },
        {
          "text": "Skincare",
          "href": "https://www.velodrom.cc/collections/cycling-skincare"
        }
      ]
    },
    {
      "text": "Lifestyle",
      "links": [
        {
          "text": "T-Shirts",
          "href": "https://www.velodrom.cc/collections/casual-urban-shirts"
        },
        {
          "text": "Sweatshirts",
          "href": "https://www.velodrom.cc/collections/casual-urban-sweatshirts"
        },
        {
          "text": "Technical T-Shirts",
          "href": "https://www.velodrom.cc/collections/technical-t-shirts"
        },
        {
          "text": "Casual Jackets",
          "href": "https://www.velodrom.cc/collections/casual-urban-jackets"
        },
        {
          "text": "Shorts",
          "href": "https://www.velodrom.cc/collections/trousers-and-shorts"
        },
        {
          "text": "Headwear",
          "href": "https://www.velodrom.cc/collections/casual-headwear"
        },
        {
          "text": "Socks",
          "href": "https://www.velodrom.cc/collections/casual-socks"
        },
        {
          "text": "Trousers",
          "href": "https://www.velodrom.cc/collections/casual-trousers"
        },
        {
          "text": "Casual Shoes and Sneakers",
          "href": "https://www.velodrom.cc/collections/casual-shoes"
        },
        {
          "text": "Backpacks",
          "href": "https://www.velodrom.cc/collections/backpacks"
        },
        {
          "text": "Coffee Mugs",
          "href": "https://www.velodrom.cc/collections/mugs"
        },
        {
          "text": "Coffee Beans",
          "href": "https://www.velodrom.cc/collections/food-and-cycling-wines"
        },
        {
          "text": "Books & Magazines",
          "href": "https://www.velodrom.cc/collections/books-magazines"
        },
        {
          "text": "Cycling Figurines",
          "href": "https://www.velodrom.cc/collections/cycling-figurines"
        },
        {
          "text": "Drinkware & Coolers",
          "href": "https://www.velodrom.cc/collections/drinkware"
        },
        {
          "text": "Fragrances and Perfumes",
          "href": "https://www.velodrom.cc/collections/perfumes"
        },
        {
          "text": "Musettes",
          "href": "https://www.velodrom.cc/collections/musettes"
        },
        {
          "text": "Wallets and Pouches",
          "href": "https://www.velodrom.cc/collections/pouches"
        }
      ]
    },
    {
      "text": "Components",
      "links": [
        {
          "text": "Road Bike Tyres",
          "href": "https://www.velodrom.cc/collections/road-bike-tyres"
        },
        {
          "text": "Gravel Tyres",
          "href": "https://www.velodrom.cc/collections/gravel-tyres-1"
        },
        {
          "text": "MTB Tyres",
          "href": "https://www.velodrom.cc/collections/mtb-tyres"
        },
        {
          "text": "Wheelsets",
          "href": "https://www.velodrom.cc/collections/wheelsets"
        },
        {
          "text": "Saddles",
          "href": "https://www.velodrom.cc/collections/saddles"
        },
        {
          "text": "Handlebars",
          "href": "https://www.velodrom.cc/collections/handlebars"
        },
        {
          "text": "Bar Tape & Grips",
          "href": "https://www.velodrom.cc/collections/bar-tape"
        },
        {
          "text": "Pedals",
          "href": "https://www.velodrom.cc/collections/pedals"
        },
        {
          "text": "Stems",
          "href": "https://www.velodrom.cc/collections/stems"
        },
        {
          "text": "Seatposts",
          "href": "https://www.velodrom.cc/collections/seatposts"
        },
        {
          "text": "Spare Parts",
          "href": "https://www.velodrom.cc/collections/spare-parts"
        }
      ]
    },
    {
      "text": "Drivetrain",
      "links": [
        {
          "text": "Cassettes",
          "href": "https://www.velodrom.cc/collections/cassettes"
        },
        {
          "text": "Cranksets",
          "href": "https://www.velodrom.cc/collections/cranksets"
        },
        {
          "text": "Chains",
          "href": "https://www.velodrom.cc/collections/chain"
        },
        {
          "text": "Chainrings",
          "href": "https://www.velodrom.cc/collections/chainrings"
        },
        {
          "text": "Front/Rear Derailleurs",
          "href": "https://www.velodrom.cc/collections/front-and-rear-derailleurs"
        },
        {
          "text": "Bottom Brackets",
          "href": "https://www.velodrom.cc/collections/bottom-brackets"
        },
        {
          "text": "Complete Groupsets",
          "href": "https://www.velodrom.cc/collections/complete-groupsets"
        },
        {
          "text": "Shifters",
          "href": "https://www.velodrom.cc/collections/shifters"
        },
        {
          "text": "Pulley and Pulley Wheels",
          "href": "https://www.velodrom.cc/collections/pulleys-and-pulley-wheels"
        },
        {
          "text": "Brake Rotors",
          "href": "https://www.velodrom.cc/collections/brake-callipers-and-rotors"
        }
      ]
    },
    {
      "text": "Computers and Electronics",
      "links": [
        {
          "text": "Lights",
          "href": "https://www.velodrom.cc/collections/lights"
        },
        {
          "text": "Front Lights",
          "href": "https://www.velodrom.cc/collections/front-lights"
        },
        {
          "text": "Rear Lights",
          "href": "https://www.velodrom.cc/collections/rear-lights"
        },
        {
          "text": "GPS Units",
          "href": "https://www.velodrom.cc/collections/gps-units"
        },
        {
          "text": "GPS Accessories and Mounts",
          "href": "https://www.velodrom.cc/collections/gps-mounts-and-accesories"
        },
        {
          "text": "Heartrate Monitors and sensors",
          "href": "https://www.velodrom.cc/collections/sensors"
        },
        {
          "text": "Indoor Training",
          "href": "https://www.velodrom.cc/collections/indoor-training"
        },
        {
          "text": "Powermeters",
          "href": "https://www.velodrom.cc/collections/powermeters"
        },
        {
          "text": "Pedal Powermeters",
          "href": "https://www.velodrom.cc/collections/powermeter-pedals"
        }
      ]
    },
    {
      "text": "Bikes And Frames",
      "links": [
        {
          "text": "Velodrom Custom Bikes",
          "href": "https://www.velodrom.cc/pages/velodrom-custom-bikes-gallery"
        },
        {
          "text": "Road Bikes",
          "href": "https://www.velodrom.cc/collections/road-bikes"
        },
        {
          "text": "Gravel Bikes",
          "href": "https://www.velodrom.cc/collections/gravel-bikes"
        },
        {
          "text": "Mountain Bikes",
          "href": "https://www.velodrom.cc/collections/mountain-bikes"
        },
        {
          "text": "E-Bikes",
          "href": "https://www.velodrom.cc/collections/e-bikes"
        },
        {
          "text": "Bike Clearance Last Units",
          "href": "https://www.velodrom.cc/collections/bikes-clearance"
        },
        {
          "text": "Framesets",
          "href": "https://www.velodrom.cc/collections/framesets-in-stock"
        },
        {
          "text": "Road Framesets",
          "href": "https://www.velodrom.cc/collections/road-framesets"
        },
        {
          "text": "Gravel Framesets",
          "href": "https://www.velodrom.cc/collections/gravel-framesets"
        },
        {
          "text": "MTB Framesets",
          "href": "https://www.velodrom.cc/collections/mtb-framesets"
        },
        {
          "text": "Specialized",
          "href": "https://www.velodrom.cc/collections/specialized-bikes"
        },
        {
          "text": "3T Cycling",
          "href": "https://www.velodrom.cc/collections/3t-bikes"
        },
        {
          "text": "Aurum Bikes",
          "href": "https://www.velodrom.cc/collections/aurum-bikes"
        },
        {
          "text": "Colnago",
          "href": "https://www.velodrom.cc/collections/colnago"
        },
        {
          "text": "Enve",
          "href": "https://www.velodrom.cc/collections/enve-bikes-and-framesets"
        },
        {
          "text": "Factor",
          "href": "https://www.velodrom.cc/collections/factor-bikes"
        },
        {
          "text": "Pinarello",
          "href": "https://www.velodrom.cc/collections/pinarello"
        }
      ]
    },
    {
      "text": "Special Prices Up to 30% off",
      "links": [
        {
          "text": "See all",
          "href": "https://www.velodrom.cc/collections/all-special-prices-products"
        },
        {
          "text": "Bundles Special Discounts",
          "href": "https://www.velodrom.cc/pages/bundle-builder"
        },
        {
          "text": "Over 30% Off",
          "href": "https://www.velodrom.cc/collections/more-than-30-discount-special-prices"
        },
        {
          "text": "Over 20% off",
          "href": "https://www.velodrom.cc/collections/more-than-20-discount-special-prices"
        },
        {
          "text": "Up to 20% off",
          "href": "https://www.velodrom.cc/collections/up-to-20-discount-special-prices"
        },
        {
          "text": "LAST UNITS",
          "href": "https://www.velodrom.cc/collections/last-units"
        },
        {
          "text": "#Cycling Apparel Special Prices",
          "href": "https://www.velodrom.cc/collections/cycling-apparel-special-prices-men"
        },
        {
          "text": "Lifestyle Special Prices",
          "href": "https://www.velodrom.cc/collections/lifestyle-special-prices"
        },
        {
          "text": "Bike Clearance Last Units",
          "href": "https://www.velodrom.cc/collections/bikes-clearance"
        }
      ]
    },
    {
      "text": "Brands",
      "href": "https://www.velodrom.cc/pages/brands",
      "links": []
    },
    {
      "text": "Second life",
      "href": "https://www.velodrom.cc/pages/second-life-program-welcome-page",
      "links": []
    }
  ],
  "shopLabel": "Shop"
};
export const navigation = snapshot.navigation;
export const categories = snapshot.categories;

export const promo = { image: 'https://www.velodrom.cc/cdn/shop/files/velodrom-menu-slide.jpg?v=1775633457&width=800', href: 'https://www.velodrom.cc/collections/velodrom-vcc', heading: 'VELODROM SS26', subheading: 'Discover our new collection', cta: 'SEE COLLECTION' };
